import { render, staticRenderFns } from "./TeacherCommunications.vue?vue&type=template&id=659d6263"
import script from "./TeacherCommunications.vue?vue&type=script&lang=js"
export * from "./TeacherCommunications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports